import { UIComponentState, UIDataModel, UIComponentHandler } from '../../../../toolkit/uicomponent';
import { BaseContext } from '../../../../../utils/basecontext';
import { UIComponentView } from '../../../../toolkit/uicomponentview';
import { UIComponentCSSStyle } from '../../../../toolkit/uicomponentcss';
import { APIFeatures } from '../../../../../core/util/apifeatures';
import { APIModelHandler, APIModel } from '../../../../toolkit/uicomponentapimodel';
import { CRBTUIComponentProps, CRBTUIComponent } from '../../crbt/crbtuicomponent';
import { ShowMoreProfileTunesCSSStyleImpl } from './showmoreprofiletunescss';
import { ShowMoreProfileTunesViewImpl } from './showmoreprofiletunesview';
import { FeaturedCategoryDto } from 'src/com/sixdee/crbtportal/core/dto/featuredcategory/featuredcategorydto';
import { ProfiletunesCategoryAPIModel, ProfiletunesCategoryAPIModelImpl } from '../profiletunesapimodel';
import { ProfileTuneViewModelImpl } from '../profiletunecard/profiletuneviewmodel';
import { AudioPlayerWithProgressImpl } from '../../../../toolkit/player/playerwithprogress/playerwithprogressimpl';





export interface ShowMoreProfileTunesComponentProps extends CRBTUIComponentProps
{
   
}

export interface ShowMoreProfileTunesComponentHandler extends UIComponentHandler
{
    onDataNotLoaded(isNotLoaded: boolean): void;
}
export interface  ShowMoreProfileTunesComponentState extends UIComponentState
{
    isDataNotLoaded: boolean;
}

export class ShowMoreProfileTunesComponent extends CRBTUIComponent<ShowMoreProfileTunesComponentProps, ShowMoreProfileTunesComponentState> 
implements ShowMoreProfileTunesComponentHandler
{
    private ShowMoreProfileTunesViewModel: ProfileTuneViewModelImpl;

    constructor(props: ShowMoreProfileTunesComponentProps)
    {
        super(props);
        this.ShowMoreProfileTunesViewModel = new ProfileTuneViewModelImpl( 
            props.context.getConfigurationSettings().getProperty("FETCH_LIMIT"), props.context, "40px", new AudioPlayerWithProgressImpl(props.context.getPlayerManager().getAudioPlayer()));
        this.ShowMoreProfileTunesViewModel.setListDatas([]);
        this.state ={isDataNotLoaded:false};
    }
     onDataNotLoaded(isNotLoaded: boolean): void 
     {
        this.setState({isDataNotLoaded: isNotLoaded});
     }

     componentDidMount()
       {
        (this.getView() as ShowMoreProfileTunesViewImpl).showLoader();
        this.getAPIModel().getProfiletunesCategories();
       }

       componentWillReceiveProps(nextProps: ShowMoreProfileTunesComponentProps)
       {
        (this.getView() as ShowMoreProfileTunesViewImpl).showLoader();
         (this.getView() as ShowMoreProfileTunesViewImpl).setListOfDatas([]);
         
           this.setState({isDataNotLoaded: false});
          
           this.getAPIModel().getProfiletunesCategories();
       }
   
   
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new ShowMoreProfileTunesViewImpl(this.ShowMoreProfileTunesViewModel, applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new ShowMoreProfileTunesCSSStyleImpl(applicationContext);
    }

    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new ProfiletunesCategoryAPIModelImpl(applicationContext, apiModelHandler);
    }

    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        console.log("------success");
        (this.getView() as ShowMoreProfileTunesViewImpl).dismissLoader();
        this.ShowMoreProfileTunesViewModel.setListDatas((data as FeaturedCategoryDto).getListOfTones());
        this.setState({ isDataNotLoaded:   this.ShowMoreProfileTunesViewModel.getListOfDatas().length > 0 ? false :  true});

        window.scroll(0,0);
    }
    onFailure(feature: APIFeatures, description: string, data: any): void 
    {
        (this.getView() as ShowMoreProfileTunesViewImpl).dismissLoader();
        this.ShowMoreProfileTunesViewModel.getListOfDatas().length = 0;
        this.setState({ isDataNotLoaded: true});
    
        window.scroll(0,0);
        }

    getAPIModel(): ProfiletunesCategoryAPIModel
    {
        return (super.getAPIModel() as ProfiletunesCategoryAPIModel);
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/profiletunes/showmoreprofiletunes/showmoreprofiletunescomponent.tsx